import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../config/api.config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {
  CreditoWhatsappPayload,
  HistorialCreditoWhatsapp,
  HistorialCreditoWhatsappFiltros,
} from '../models/credito-whatsapp.model';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CreditoWhatsappService {
  private apiUrl = API_ENDPOINTS.creditoWhatsapp;

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  constructor(private http: HttpClient) {}

  actualizarCreditos(telefonoId: number, dto: CreditoWhatsappPayload) {
    return this.http
      .put(this.apiUrl + `/actualizar/${telefonoId}`, dto, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  obtenerHistorial(filtros: HistorialCreditoWhatsappFiltros) {
    let params = new HttpParams();

    Object.entries(filtros).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return this.http
      .get<HistorialCreditoWhatsapp[]>(`${this.apiUrl}/historial`, {
        ...this.httpOptions,
        params,
      })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any): Observable<never> {
    const message =
      error?.error?.message || error?.message || 'Error en la solicitud';
    return throwError(() => new Error(message));
  }
}
